import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import Project from 'src/api/project';
import { CLEAR_REQUEST_ERRORS, FETCH_NOTIFICATIONS } from 'src/store/types';
import FormatUtils from 'src/utils/formatters';
import ToggleSliderInput from 'components/forms/ToggleSliderInput.vue';
import { BfSpinner, BfTextInput, BfButton, BfModal, BfDialog } from 'components/Butterfly';
import { Form, Field } from 'components/forms';
import IntegrationButton from './IntegrationButton.vue';
import slackIcon from 'assets/img/slack.svg';
import teamsIcon from 'assets/img/microsoft-teams.svg';
const PROVIDERS = ['slack', 'teams'];
const NotificationPage = Vue.extend({
    components: {
        ToggleSliderInput,
        BfTextInput,
        Form,
        Field,
        BfButton,
        BfSpinner,
        BfModal,
        BfDialog,
        IntegrationButton,
    },
    data() {
        return {
            providers: PROVIDERS,
            providerIcons: {
                slack: slackIcon,
                teams: teamsIcon
            },
            isLoading: true,
            toDelete: undefined,
            serverError: '',
            showDeleteModal: false,
            slackUpdateModal: false,
            teamsUpdateModal: false,
        };
    },
    computed: {
        ...mapGetters(['featureFlags', 'currentSite', 'notifications']),
        initialFormValues() {
            return {
                slack: {
                    slackWebHookURL: this.notifications?.slack?.details?.webhook_url ?? '',
                    slackEnabled: this.notifications?.slack?.enabled ?? true,
                },
                teams: {
                    teamsWebHookURL: this.notifications?.teams?.details?.webhook_url ?? '',
                    teamsEnabled: this.notifications?.teams?.enabled ?? true,
                },
            };
        },
        isEnabled() {
            return this.providers.reduce((obj, provider) => {
                if (provider in this.notifications) {
                    obj[provider] = this.notifications[provider].enabled ?? false;
                }
                else {
                    obj[provider] = null;
                }
                return obj;
            }, {});
        },
        isConfigured() {
            return this.providers.reduce((obj, provider) => {
                if (provider in this.notifications) {
                    obj[provider] = true;
                }
                else {
                    obj[provider] = false;
                }
                return obj;
            }, {});
        },
    },
    metaInfo() {
        return {
            title: `${this.currentSite?.site_name} Notifications - Kapiche`
        };
    },
    async mounted() {
        this.getNotifications();
    },
    methods: {
        ...mapActions({
            FETCH_NOTIFICATIONS,
        }),
        startCase: FormatUtils.startCase,
        clearErrorMessage() {
            this.serverError = '';
        },
        updateNotification(type) {
            return async (values) => {
                const endpoint = this.notifications.hasOwnProperty(type) === false
                    ? Project.createNotification
                    : Project.updateNotification;
                const payload = { type };
                if (type === 'slack') {
                    Object.assign(payload, {
                        'enabled': values.slackEnabled,
                        'details': {
                            'webhook_url': values.slackWebHookURL,
                        },
                    });
                }
                else if (type === 'teams') {
                    Object.assign(payload, {
                        'enabled': values.teamsEnabled,
                        'details': {
                            'webhook_url': values.teamsWebHookURL,
                        },
                    });
                }
                try {
                    this.isLoading = true;
                    await endpoint(payload);
                    await this.getNotifications();
                    this.slackUpdateModal = false;
                    this.teamsUpdateModal = false;
                }
                catch (resp) {
                    if (resp.status === 400) {
                        this.$store.dispatch(CLEAR_REQUEST_ERRORS); // custom error handling
                        let errors = await resp.json();
                        if (errors.hasOwnProperty('non_field_errors')) {
                            this.serverError = errors['non_field_errors'][0];
                        }
                        else {
                            const key = Object.keys(errors)[0];
                            this.serverError = `${key}: ${errors[key][0]}`;
                        }
                    }
                }
                finally {
                    this.isLoading = false;
                }
            };
        },
        async removeNotification(provider) {
            this.isLoading = true;
            try {
                await Project.deleteNotification(provider);
                this.showDeleteModal = false;
                await this.getNotifications();
            }
            finally {
                this.isLoading = false;
            }
        },
        popModal(provider) {
            // Set the default value for the input field for the modal
            if (this.isConfigured[provider]) {
                if (provider === 'slack') {
                    const current = this.notifications['slack'];
                    this.$refs.slackForm?.resetForm({
                        slackWebHookURL: current.details?.webhook_url ?? '',
                        slackEnabled: current.enabled ?? '',
                    });
                }
                else if (provider === 'teams') {
                    const current = this.notifications['teams'];
                    this.$refs.teamsForm?.resetForm({
                        teamsWebHookURL: current.details?.webhook_url ?? '',
                        teamsEnabled: current.enabled ?? '',
                    });
                }
            }
            if (provider === 'slack') {
                this.slackUpdateModal = true;
            }
            else if (provider === 'teams') {
                this.teamsUpdateModal = true;
            }
        },
        popDeleteModal(provider) {
            this.toDelete = provider;
            this.showDeleteModal = true;
        },
        async getNotifications() {
            this.isLoading = true;
            try {
                await this.FETCH_NOTIFICATIONS();
            }
            finally {
                this.isLoading = false;
            }
        },
    },
});
export default NotificationPage;
